<!--
    描述：权限列表
    时间：2020-04-22
    Created by sjq
-->
<template>
	<div class="h100">
		<div class="w-page-main">
			<div class="w-page-header superiors-search-area">
				<div class="left-text overflow-hidden">
					<span><b>权限列表</b></span>
				</div>
				<div class="btnGroups">
					<el-button type="primary"
							   icon="el-icon-circle-plus"
							   size="small"
							   @click="add()">新增</el-button>
				</div>
			</div>

			<div class="w-page-container pdb10">
				<div class="w-table-layout">
					<div class="w-table-content"
						 ref="menusContent">
						<el-table :data="treeData.tableData"
								  row-key="id"
								  v-loading="treeData.loading"
								  ref="menusTree"
								  default-expand-all
								  :height="treeData.tableH"
								  border
								  highlight-current-row
								  @row-click="rowClick"
								  :tree-props="{children: 'children'}">
							<el-table-column prop="sname"
											 label="名称"
											 align="center"
											 show-overflow-tooltip></el-table-column>
							<el-table-column prop="createDate"
											 label="创建日期"
											 align="center"
											 show-overflow-tooltip
											 width="180"></el-table-column>
							<el-table-column label="操作"
											 align="center"
											 width="150">
								<template slot-scope="scope">
									<el-button size="mini"
											   icon="el-icon-circle-plus"
											   title="新增"
											   type="text"
											   @click="add(scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-edit"
											   title="编辑"
											   type="text"
											   @click="edit(scope.row)"></el-button>
									<el-button size="mini"
											   icon="el-icon-delete"
											   title="删除"
											   type="text"
											   @click="deleteRow(scope.row)"></el-button>
								</template>
							</el-table-column>
						</el-table>
					</div>
				</div>
			</div>
		</div>

		<!-- 新增、编辑等弹窗 -->
		<el-dialog :title="dialogObj.title"
				   :visible.sync="dialogObj.visible"
				   :width="dialogObj.width"
				   center
				   :close-on-click-modal="false">
			<div>
				<div>
					<el-input v-model="query.sname"></el-input>
				</div>
			</div>
			<!-- footer 组件 -->
			<div slot="footer"
				 class="dialog-footer text-center"
				 v-if="dialogObj.mode !== 'view'">
				<el-button size="small"
						   @click="dialogObj.visible = false">取 消</el-button>
				<el-button type="primary"
						   size="small"
						   :loading="btnLoading"
						   @click="save">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import { selectAll, saveOrUpdate, deleteById } from 'api/system/roleLimit.js'

export default {
	props: {
		value: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			transObj: {
				id: '',
				parentId: '',
				parentName: '',
				type: ''
			},
			btnLoading: false,
			dialogObj: {
				title: '',
				visible: false,
				width: '650px'
			},
			treeData: {
				loading: false,
				tableH: 200,
				tableData: []
			},
			query: {
				id: '',
				sname: '',
				parentId: '',
				limitType: ''
			}
		}
	},
	computed: {
		...mapState('app', { clientSize: state => state.clientSize }),
		...mapState('menu', {
			roleBtns: state => state.roleBtns
		})
	},
	methods: {
		// 请求主表
		selectAll() {
			selectAll().then(res => {
				this.treeData.tableData = this.$utils.toArrayTree(res.data)
				console.log(this.treeData.tableData)
			})
		},

		// 新增、修改、删除等操作按钮点击事件
		doClick(obj, type) {
			let that = this
			that.dialogObj.mode = type
			if (type === 'add') {
				this.transObj.id = ''
				if (obj != '') {
					that.transObj.type = 'addSon'
					this.transObj.parentId = obj.id
					this.transObj.parentName = obj.roleName
				} else {
					that.transObj.type = 'addParent'
					this.transObj.parentId = '0'
					this.transObj.parentName = ''
				}
				this.dialogObj.title = '新增角色'
				this.dialogObj.visible = true
			} else if (type === 'edit') {
				that.transObj.type = 'edit'
				this.transObj.id = obj.id
				this.transObj.parentId = ''
				this.transObj.parentName = ''
				this.dialogObj.title = '编辑角色'
				this.dialogObj.visible = true
			} else if (type === 'delete') {
				this.delete(obj)
			}
		},

		// 删除
		delete(obj) {
			let that = this
			this.$confirm(
				'删除角色信息，将会删除角色菜单、角色菜单按钮、权限数据等信息，确认删除吗?',
				'提示',
				{
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}
			).then(() => {
				let param = {
					id: obj.id
				}
				deleteById(param).then(res => {
					if (res.operationCode == 1) {
						that.$message({ message: '删除成功', type: 'success' })
						that.getMenuTreeTableData()

						let obj = {
							id: '',
							roleName: ''
						}
						this.$emit('row-click', obj)
					} else {
						that.$message({ message: res.msg, type: 'error' })
					}
				})
			})
		},

		rowClick(obj) {
			this.$emit('row-click', obj.id)
			this.$emit('input', obj.id)
		},

		// 确定按钮事件
		doSave() {
			this.$refs.addMenu.doSave()
		},

		// 新增/编辑菜单成功
		handleSuccess() {
			this.dialogObj.visible = false
			this.getMenuTreeTableData()
		},

		// 权限新增
		add(row) {
			this.dialogObj.title = '新增'
			this.query.id = ''
			this.query.parentId = ''
			this.query.sname = ''
			if (row) {
				// console.log(row)
				this.query.parentId = row.id
			}

			this.dialogObj.visible = true
		},

		// 权限编辑
		edit(row) {
			// console.log(row)
			this.dialogObj.title = '编辑'
			this.query.sname = row.sname
			this.query.id = row.id
			this.query.parentId = ''

			this.dialogObj.visible = true
		},

		// 保存
		save() {
			saveOrUpdate(this.query).then(res => {
				console.log(res)
				this.selectAll()
				this.dialogObj.visible = false
			})
		},

		// 权限删除
		deleteRow(row) {
			this.$confirm('删除此项, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteById({
					id: row.id
				}).then(res => {
					this.selectAll()
				})
			})
		}
	},
	mounted() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	created() {
		this.selectAll()
	},
	// 缓存页面进入时
	activated() {
		this.$nextTick(() => {
			setTimeout(() => {
				this.treeData.tableH = this.$refs.menusContent.offsetHeight
			}, 100)
		})
	},
	watch: {
		clientSize(val) {
			this.treeData.tableH = this.$refs.menusContent.offsetHeight
		}
	}
}
</script>

<style lang="less" scoped>
.w-table-page {
	padding-bottom: 5px;
}
</style>
